export default "__VITE_ASSET__qaNU3R0h__"